import { loadScript } from '../../utils/loadScript';

export interface IEyeAbleConfig {
    enabled: boolean; // vom Backend
    configUrl?: string; // z.B. https://cdn.eye-able.com/configs/<kunde>.js
    mainUrl?: string; // default: https://cdn.eye-able.com/public/js/eyeAble.js
    cspNonce?: string; // optional, falls ihr CSP Nonces nutzt
}

const DEFAULT_MAIN = 'https://cdn.eye-able.com/public/js/eyeAble.js';

let loaded = false;

export async function enableEyeAble(cfg: IEyeAbleConfig) {
    if (loaded) return; // mehrfaches Laden verhindern
    if (!cfg.enabled) return;

    const attrs: Record<string, string> = cfg.cspNonce ? { nonce: cfg.cspNonce } : {};

    // 1) Domain-/Kunden-spezifische Konfiguration laden (falls vorhanden)
    if (cfg.configUrl) {
        await loadScript(cfg.configUrl, 'eyeable-config', attrs);
    }

    // 2) Hauptskript laden
    await loadScript(cfg.mainUrl ?? DEFAULT_MAIN, 'eyeable-main', attrs);

    loaded = true;

    // Optional: Auf Ready-Event warten (falls du danach etwas triggern willst)
    window.addEventListener(
        'eyeable:init_completed' as any,
        () => {
            // z.B. Logging, Telemetrie, eigenes UI informieren
            // console.info("Eye-Able bereit");
        },
        { once: true },
    );
}

export function disableEyeAble() {
    // „Harter“ Cleanup – nur verwenden, wenn du wirklich entladen willst.
    // In der Praxis lässt man das Widget meist geladen, bis zur nächsten Seite.
    const ids = ['eyeable-config', 'eyeable-main'];
    ids.forEach((id) => document.getElementById(id)?.remove());
    // Wenn Eye-Able globale Knoten oder Styles injiziert hat, bleiben die i.d.R. bestehen.
    // Ein offizielles „dispose“ ist meines Wissens nicht öffentlich dokumentiert;
    // falls ihr eine API bekommt, hier aufrufen.
    loaded = false;
}
